export default __webpack_public_path__ + "static/media/TimberTradeTrajectory.14bee5f6.png";